import { type MRT_ColumnDef } from 'material-react-table';
import StatusChip from '../StatusChip';

export function idColumn<T extends { id: number }>(): MRT_ColumnDef<T> {
  return { accessorKey: 'id', header: 'ID', size: 110, filterFn: 'equalsString',
    muiFilterTextFieldProps: { placeholder: 'Exact ID', slotProps: { htmlInput: { inputMode: 'numeric' } } } };
}
export function booleanColumn<T extends { id: number }>(field: keyof T & string, header: string, trueLabel = 'Yes', falseLabel = 'No'): MRT_ColumnDef<T> {
  return { accessorKey: field, header, size: 165, filterVariant: 'checkbox',
    muiFilterCheckboxProps: ({ column }) => ({ title: column.getFilterValue() === 'true' ? `${trueLabel} only` : column.getFilterValue() === 'false' ? `${falseLabel} only` : trueLabel === 'Active' ? 'All statuses' : 'All values', inputProps: { 'aria-label': `${header} filter: All, ${trueLabel}, ${falseLabel}` } }),
    Cell: ({ row }) => {
      const enabled = Boolean(row.original[field]);
      return <StatusChip enabled={enabled} trueLabel={trueLabel} falseLabel={falseLabel} />;
    } };
}
